import { render, staticRenderFns } from "./commonDetail.vue?vue&type=template&id=6a1577e2&scoped=true&"
import script from "./commonDetail.vue?vue&type=script&lang=js&"
export * from "./commonDetail.vue?vue&type=script&lang=js&"
import style0 from "./commonDetail.vue?vue&type=style&index=0&id=6a1577e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1577e2",
  null
  
)

export default component.exports